// 下方向のスクロールでヘッダーを隠し、上方向とキーボード操作で再表示する
export function initHeader($) {
  const header = document.querySelector('.js-home-header');
  if (!header) return;
  const hero = document.querySelector('.p-home-hero');
  let threshold = 0;
  let lastScroll = window.scrollY;
  let scheduled = false;

  function update() {
    const scroll = window.scrollY;
    const keyboardFocus = header.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
    if (scroll <= threshold || scroll < lastScroll - 2 || keyboardFocus) header.classList.remove('is-hidden');
    else if (scroll > lastScroll + 2) header.classList.add('is-hidden');
    lastScroll = scroll;
    scheduled = false;
  }
  function measure() {
    threshold = hero ? hero.offsetHeight : header.offsetHeight;
    update();
  }
  $(window).on('scroll.header', function () {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(update);
    }
  }).on('resize.header', measure);
  $(header).on('focusin', function () { header.classList.remove('is-hidden'); });
  measure();
  if (document.fonts) document.fonts.ready.then(measure);
}
